export default __webpack_public_path__ + "static/media/bda.ab0a088f.jpg";